import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import useIsMobileApp from "../hooks/useIsMobileApp"

const UsePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        device_type: !useIsMobileApp() ? "web" : "app",
        page: location.pathname + location.search,
      },
    });
  }, [location]);
};

export default UsePageTracking;
